import { httpClient } from '@/api/httpClient';

export async function enterWorkspaceAsPlatformAdmin(tenantId: string): Promise<void> {
  await httpClient.post('/me/workspace-access/' + tenantId);
}
